import React, { useLayoutEffect, useState } from "react";
import { LiveFeedApi, LiveFeedDto, LiveFeedState } from "../lib-api";
import { apiConfiguration } from "../api-configuration";
import useInterval from "../hooks/useInterval";
import { createRoot } from "react-dom/client";

const api = new LiveFeedApi(apiConfiguration);

export const LiveFeed: React.FC<{
  liveFeedId: string;
}> = (props) => {
  const [feed, setFeed] = useState<LiveFeedDto>();

  const initailLoad = async () => {
    await api
      .getLiveFeed({ id: props.liveFeedId })
      .then((data) => {
        setFeed(data);
      })
      .catch(() => { });
  };

  useInterval(async () => {
    await api
      .getLiveFeed({ id: props.liveFeedId })
      .then((data) => {
        setFeed(data);
      })
      .catch(() => { });
  }, 2000);

  useLayoutEffect(() => {
    setTimeout(() => {
      initailLoad();
    }, 0);
  }, []);

  return (
    <>
      {feed && (
        <>
          <div>
            <h3>
              {feed.state == LiveFeedState.Live && (
                <>
                  <img
                    src="/img/util/live-beacon.svg"
                    style={{ height: "20px", marginRight: "5px" }}
                  />
                  <span className="mr-1">LIVE:</span>
                </>
              )}
              {feed.name}
            </h3>
          </div>
          {feed.messages.map((message) => (
            <div key={message.id} className="mb-2">
              <div
                className="mb-3 mt-1 p-2"
                style={{
                  border: "1px solid #DCDCDC",
                  backgroundColor: "#F7F7F7",
                }}
              >
                <div className="font-weight-bold small">
                  {message.created}
                  {message.author && (
                    <span className="font-weight-normal">
                      {" "}
                      - {message.author}
                    </span>
                  )}
                </div>
                <div
                  className="mt-2"
                  style={{ fontSize: "18px" }}
                  dangerouslySetInnerHTML={{
                    __html: message.message.replace(
                      new RegExp("\r\n", "g"),
                      "<br />"
                    ),
                  }}
                />
                {message.imageUrl && (
                  <div className="mt-2">
                    <a
                      href={message.largeImageUrl ?? ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={message.imageUrl} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

const livefeedElements = document.getElementsByTagName("livefeed");
Array.from(livefeedElements).forEach((item) => {
  const element = item as HTMLElement;

  const root = createRoot(element);
  root.render(<LiveFeed liveFeedId={element.dataset.livefeedid!} />);
});
